import styled from 'styled-components';
import { CloseButtonInModal } from '../../../common/CloseButtonInModal';
import TransitioningModal from '../../TransitioningModal';
import { desktopMediaQuery } from '../../../../styleHelpers';
import { BACKGROUND_COLOR } from '../../../../constants';
import HomePageGeneratorInputSection from '../../../../features/HomePageGenerator/HomePageGeneratorInputSection';
import { useEffect } from 'react';
import { useImageGenerationSettingsContext } from '../../../../context/ImageGenerationSettingsProvider';
import useChatHelpers from '../../../../hooks/chat/useChatHelpers';

interface CreateImageModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const CreateImageModal = ({ show, setShow }: CreateImageModalProps) => {
  const { currentImageFullObject } = useChatHelpers();
  const { setUserPrompt, setEngine } = useImageGenerationSettingsContext();
  const handleClose = () => setShow(false);

  useEffect(() => {
    const fakeImageObject = currentImageFullObject;
    if (!fakeImageObject) return;
    setUserPrompt(fakeImageObject.prompt);
    setEngine(fakeImageObject.engine);
  }, [show]);

  return (
    <Modal
      isOpen={show}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 100,
        },
        content: {
          position: 'relative',
          backgroundColor: BACKGROUND_COLOR,
          padding: '16px',
          width: '90vw',
          maxWidth: '800px',
          height: 'auto',
          margin: 'auto',
          marginTop: '4vh',
        },
      }}
      ariaHideApp={false}
      shouldFocusAfterRender={false}
      onRequestClose={handleClose}
    >
      <CloseButtonInModal onClick={handleClose} />
      <Title>Create an image</Title>
      <ContentContainer>
        💬 Enter Image Prompt:
        <HomePageGeneratorInputSection inChatGenerator />
      </ContentContainer>
    </Modal>
  );
};

const Modal = styled(TransitioningModal)`
  display: flex;
  flex-direction: column;
  z-index: 3;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 16px;
`;

const Title = styled.h2`
  font-size: 24px;
  margin: 8px 0 2px 0;
  text-align: center;
  color: inherit;

  ${desktopMediaQuery} {
    font-size: 28px;
  }
`;

export default CreateImageModal;
